import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Attachment } from '../../utils/types';
import { FILE_TYPES } from '../../utils/constant';
import { FileUploadService } from '../../services/file-upload.service';
import { FileViewerComponent } from '../file-viewer/file-viewer.component';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-thumbnail',
  imports: [CommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './thumbnail.component.html',
  styleUrl: './thumbnail.component.scss'
})
export class ThumbnailComponent {
  protected fileUploadService = inject(FileUploadService);
  private dialog = inject(MatDialog);

  attachments = input<Attachment[]>([]);
  hideRemoveButton = input<boolean>(false);
  variant = input<'small' | 'large'>('small');
  removeFile = output<number>();

  FILE_TYPES = FILE_TYPES;

  removeFileHandler(index: number) {
    this.removeFile.emit(index);
  }

  getSelectedFile(file: Attachment) {
   if(file.type.includes(FILE_TYPES.Pdf)) {
    return {
      icon: 'picture_as_pdf',
      className: 'pdf'
    }
   } else if(file.type.includes(FILE_TYPES.Docx)) {
    return {
      icon: 'description',
      className: 'docx'
    }
   }
  }

  openFileViewer(index: number): void {
    this.dialog.open(FileViewerComponent, {
      data: {
        files: [...this.attachments()],
        startIndex: index
      },
      width: '100%',
      height: '100%',
      maxWidth: '100vw',
      maxHeight: '100vh',
      panelClass: 'fullscreen-dialog',
    });
  }

  formatFileSize(bytes: number): string {
    if (bytes === 0) return '0 Bytes';
    const k = 1024;
    const sizes = ['Bytes', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
  }
}
